import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { ConfigurationFile } from 'containers/misc'
import {
  Input,
  InputPhone,
  RadioGroup,
  Radio,
  RadioError
} from 'components/fields'
import { Note } from 'components/misc'
import { DELIVERY_TYPES, CONFIGURATION_KEYS } from 'constants/enums'

export default class Parent extends Component {
  static propTypes = {
    values: PropTypes.object,
    onGetConfigurationValues: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired
  }

  componentDidMount = async() => {
    const { values } = this.props

    const organizationId = get(values, 'organizationId')

    // parentalConsent is included here rather than fetched by the ConfigurationFile below
    await this.props.onGetConfigurationValues(
      [
        CONFIGURATION_KEYS.participantRegistrationParentalConsentElectronically.id,
        CONFIGURATION_KEYS.participantRegistrationParentalConsentNotRequired.id,
        CONFIGURATION_KEYS.participantRegistrationParentalConsentPaper.id,
        CONFIGURATION_KEYS.parentalConsent.id
      ],
      organizationId,
      true
    )
  }

  render() {
    const { values, configuration } = this.props

    const selectedCountryIcoCode = get(
      values,
      'helpers.selectedCountry.isoCode'
    )

    const parentalConsentElectronically = get(
      configuration,
      `values[${CONFIGURATION_KEYS.participantRegistrationParentalConsentElectronically.id}].booleanValue`
    )

    const parentalConsentNotRequired = get(
      configuration,
      `values[${CONFIGURATION_KEYS.participantRegistrationParentalConsentNotRequired.id}].booleanValue`
    )

    const parentalConsentPaper = get(
      configuration,
      `values[${CONFIGURATION_KEYS.participantRegistrationParentalConsentPaper.id}].booleanValue`
    )

    return (
      <div>
        <div className='row'>
          <div className='col-xs-12 col-md-4'>
            <Input
              name='parentFirstName'
              label='Your parent/guardian first name'
              intlKey='label.your_parent_first_name'
            />
          </div>
          <div className='col-xs-12 col-md-4'>
            <Input
              name='parentLastName'
              label='Your parent/guardian last name'
              intlKey='label.your_parent_last_name'
            />
          </div>
          <div className='col-xs-6 col-md-4'>
            <Input
              name='parentRelationship'
              label='Relationship'
              intlKey='label.relationship'
            />
          </div>
        </div>

        <div className='row'>
          <div className='col-xs-6 col-md-4'>
            <InputPhone
              name='parentPhone'
              label='Phone'
              intlKey='label.phone'
              selectedCountryIcoCode={selectedCountryIcoCode}
            />
          </div>
          <div className='col-xs-6 col-md-4'>
            <Input
              name='parentEmail'
              label='Email'
              intlKey='label.email'
            />
          </div>
          <div className='col-xs-6 col-md-4'>
            <Input
              name='parentEmailCheck'
              label='Confirm email'
              intlKey='label.confirm_email'
            />
          </div>
        </div>

        <div className='row'>
          <div className='col-xs-12'>
            <RadioGroup
              label='How do you want to apply:'
              intlKey='label.how_do_you_want_to_apply'
            >
              {parentalConsentElectronically &&
              <Radio
                name='consentDeliveryType.value'
                label='My parent/guardian will confirm consent by email'
                intlKey='label.my_parent_will_confirm_consent_by_email'
                value={DELIVERY_TYPES.ELECTRONICALLY.value}
              />}

              {parentalConsentNotRequired &&
              <Radio
                name='consentDeliveryType.value'
                label='My parent/guardian consent has been already given/send to my Award Leader'
                intlKey='label.my_parent_consent_has_been_already_given'
                value={DELIVERY_TYPES.NOT_REQUIRED.value}
              />}

              {parentalConsentPaper &&
              <Radio
                name='consentDeliveryType.value'
                label='My parent/guardian will complete and sign the parent/guardian Consent form'
                intlKey='label.my_parent_will_complete_and_sign_form'
                value={DELIVERY_TYPES.PAPER.value}
              />}

              {get(values, 'consentDeliveryType.value') ===
              DELIVERY_TYPES.PAPER.value &&
              <div className='row'>
                <div className='col-xs-6'>
                  <Note>
                    <FormattedMessage
                      id='label.please_print_it_tak_it_to_your_parent'
                      defaultMessage='Please print it, take it to your parent/guardian for signing and then give it to your Award Leader'
                    />
                  </Note>
                  <ConfigurationFile
                    configKey={CONFIGURATION_KEYS.parentalConsent.id}
                    organizationId={get(values, 'organizationId')}
                    isPublic
                    noFetch
                    formattedName={
                      <FormattedMessage
                        id='button.parent_guardian_consent_pdf'
                        defaultMessage='Parent/guardian consent.pdf'
                      />
                    }
                  />
                </div>
              </div>}
              <RadioError name='consentDeliveryType.value' />
            </RadioGroup>
          </div>
        </div>
      </div>
    )
  }
}
